import { FormType } from '../../../form-types';

import { EnclomipheneQuestionFieldAnswers } from './questions';

const enclomiphene: FormType<EnclomipheneQuestionFieldAnswers> = {
  name: 'Testosterone Support',
  questions: [
    {
      key: 'enclomiphene_sexAssignedAtBirth',
      next: {
        condition: {
          'enclomiphene_sexAssignedAtBirth.male': true
        },
        key: 'generic_heightWeight2025',
        els: 'enclomiphene_ineligible'
      }
    },
    'generic_heightWeight2025',
    {
      key: 'enclomiphene_physicalExam',
      next: {
        condition: { 'enclomiphene_physicalExam.yes_problems': true },
        key: 'enclomiphene_physicalExam_issues',
        els: 'enclomiphene_hospitalizations'
      }
    },
    'enclomiphene_physicalExam_issues',
    {
      key: 'enclomiphene_hospitalizations',
      next: {
        condition: { 'enclomiphene_hospitalizations.yes': true },
        key: 'enclomiphene_hospitalizations_details',
        els: 'enclomiphene_conditions'
      }
    },
    'enclomiphene_hospitalizations_details',
    {
      key: 'enclomiphene_conditions',
      next: {
        condition: { 'enclomiphene_conditions.enclomiphene_none': true },
        key: 'enclomiphene_symptoms',
        els: 'enclomiphene_conditions_details'
      }
    },
    'enclomiphene_conditions_details',
    {
      key: 'enclomiphene_symptoms',
      next: {
        condition: {
          'enclomiphene_symptoms.none': true
        },
        key: 'enclomiphene_previousTreatment',
        els: 'enclomiphene_symptomsDetails'
      }
    },
    'enclomiphene_symptomsDetails',
    'enclomiphene_symptomsDuration',
    {
      key: 'enclomiphene_previousTreatment',
      next: {
        condition: { 'enclomiphene_previousTreatment.yes': true },
        key: 'enclomiphene_treatmentDetails',
        els: 'enclomiphene_currentlyTakingEnclomiphene'
      }
    },
    'enclomiphene_treatmentDetails',
    'enclomiphene_previousDose',
    'enclomiphene_lastUseDate',
    'enclomiphene_doseSatisfaction',
    {
      key: 'enclomiphene_previousComplications',
      next: {
        condition: { 'enclomiphene_previousComplications.yes': true },
        key: 'enclomiphene_previousSideEffects',
        els: 'enclomiphene_currentlyTakingEnclomiphene'
      }
    },
    'enclomiphene_previousSideEffects',
    {
      key: 'enclomiphene_currentlyTakingEnclomiphene',
      next: {
        condition: { 'enclomiphene_currentlyTakingEnclomiphene.yes': true },
        key: 'enclomiphene_currentComplications',
        els: 'enclomiphene_polycythemia'
      }
    },
    {
      key: 'enclomiphene_currentComplications',
      next: {
        condition: {
          'enclomiphene_currentComplications.yes_side_effects': true
        },
        key: 'enclomiphene_currentSideEffects',
        els: 'enclomiphene_currentDose'
      }
    },
    'enclomiphene_currentSideEffects',
    'enclomiphene_currentDose',
    'enclomiphene_currentDoseSatisfaction',
    {
      key: 'enclomiphene_polycythemia',
      next: {
        condition: { 'enclomiphene_polycythemia.yes': true },
        key: 'enclomiphene_ineligible',
        els: 'enclomiphene_hypertension'
      }
    },
    {
      key: 'enclomiphene_hypertension',
      next: {
        condition: { 'enclomiphene_hypertension.yes': true },
        key: 'enclomiphene_bpControlled',
        els: 'enclomiphene_tobacco'
      }
    },
    {
      key: 'enclomiphene_bpControlled',
      next: {
        condition: { 'enclomiphene_bpControlled.no': true },
        key: 'enclomiphene_ineligible',
        els: 'enclomiphene_averageBP'
      }
    },
    'enclomiphene_averageBP',
    {
      key: 'enclomiphene_tobacco',
      next: {
        condition: { 'enclomiphene_tobacco.yes': true },
        key: 'enclomiphene_tobaccoFrequency',
        els: 'enclomiphene_alcohol'
      }
    },
    'enclomiphene_tobaccoFrequency',
    {
      key: 'enclomiphene_alcohol',
      next: {
        condition: { 'enclomiphene_alcohol.yes': true },
        key: 'enclomiphene_alcoholFrequency',
        els: 'enclomiphene_exercise'
      }
    },
    'enclomiphene_alcoholFrequency',
    'enclomiphene_exercise',
    {
      key: 'enclomiphene_currentlyHaveLabs',
      next: {
        condition: { 'enclomiphene_currentlyHaveLabs.yes': true },
        key: 'enclomiphene_InitialLabsUpload',
        els: 'enclomiphene_additionalInfo'
      }
    },
    'enclomiphene_InitialLabsUpload',
    'enclomiphene_additionalInfo',
    {
      key: 'enclomiphene_consentTruthfulness',
      next: {
        condition: { 'enclomiphene_consentTruthfulness.non_consent': true },
        key: 'enclomiphene_didNotConsent',
        els: 'enclomiphene_consentTreatment'
      }
    },
    {
      key: 'enclomiphene_consentTreatment',
      next: {
        condition: { 'enclomiphene_consentTreatment.non_consent': true },
        key: 'enclomiphene_didNotConsent',
        els: 'enclomiphene_complete'
      }
    },
    'enclomiphene_ineligible',
    'enclomiphene_didNotConsent',
    'enclomiphene_complete'
  ]
};
export default enclomiphene;
